//var LocalIP="https://machinery-souk-8c1dbb69a2ab.herokuapp.com/"

var LocalIP="http://localhost:3500/"

export default LocalIP